<template>
  <router-link
    :to="i18nRoute({ name: 'actor page', params: { id: props.castCrew.slug || props.castCrew.id || props.castCrew._id } })"
    class="card">
    <div class="card__img">
      <img v-if="castCrew?.poster_url || castCrew?.images?.length" :src="castCrew.poster_url || castCrew.images[0]"
        alt="">
      <div v-else class="card__img-no">
        <font-awesome-icon icon="user-slash" />
      </div>
    </div>
    <p class="card__title">
      {{ castCrew.title || `${isObject(castCrew.firstName) ? castCrew.firstName[language] : castCrew.firstName}
            ${isObject(castCrew.firstName) ? castCrew.lastName[language] : castCrew.lastName}` }}
    </p>
  </router-link>
</template>

<script setup>
import { isObject } from 'lodash';
import { i18nRoute } from '@/utils/useTranslate';
import { useStore } from 'vuex';
import { computed } from 'vue';

const store = useStore()
const language = computed(() => store.state.language)

const props = defineProps({
  castCrew: {
    type: Object,
  }
})
</script>

<style lang="scss" scoped>
.card {
  margin-bottom: rem(40);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  cursor: pointer;

  @include media-breakpoint-down(xs) {
    margin-bottom: rem(0);
  }

  // .card__img 

  &__img {
    border-radius: 50%;
    background-color: $base-gray-color;
    display: flex;
    align-items: center;
    justify-content: center;
    height: rem(168);
    width: rem(168);
    overflow: hidden;
    position: relative;

    @include media-breakpoint-down(xs) {
      height: rem(83);
      width: rem(83);
    }

    img {
      @extend %img-view;
    }
  }

  // .card__img-no

  &__img-no {
    font-size: rem(40);
  }

  // .card__title

  &__title {
    color: #DDDDDD;
    font-weight: 500;
    font-size: 20px;
    line-height: math.div(32, 20);
    text-align: center;

    @include media-breakpoint-down(xs) {
      font-weight: 500;
      font-size: rem(14);
      line-height: math.div(17, 14);
    }
  }
}
</style>